export const BUTTON_NAME = "Apply Filter"

export const HEADER_TEXT = {
    title: "Refine the dataset",
    description: "Choose the timeframe, surveys and rater groups you want to analyze."
}
